import { PackageIcon, Plus } from 'lucide-react';
import { useSession } from 'next-auth/react';
import { useState } from 'react';

import { AppLayout } from '@/components/layouts/app-layout';
import { Link } from '@/components/link';
import { TrackingAuthWrapper } from '@/components/modules/shipment/auth-wrapper';
import { TrackingRequestPending } from '@/components/modules/tracking-request/pending';
import { useTrackingRequestsPending } from '@/hooks/use-tracking-requests-pending';
import { SITE_NAME, TRACKING_IMPORT_URL, USER_ACCESS_FEATURES } from '@/lib/constants';
import { canAccessFeature } from '@/utils/auth';
import { ShipmentListViewController } from '@/view-controllers/shipments/list';

const Page = () => {
  const { data: session } = useSession();
  const canAccessTracking = canAccessFeature(USER_ACCESS_FEATURES.TRACKING, session);
  const [shouldFetchCountOnly, setShouldFetchCountOnly] = useState(true);
  const { trackingRequests, count } = useTrackingRequestsPending({ countOnly: shouldFetchCountOnly });

  return (
    <AppLayout
      title={`Tracking - ${SITE_NAME}`}
      breadcrumbItems={[
        { label: 'Tracking' },
        { label: 'Active shipments', icon: <PackageIcon className="text-lightBlue-500" /> },
      ]}
      breadcrumbActions={
        canAccessTracking ? (
          <div className="flex items-center gap-3">
            {count ? (
              <TrackingRequestPending
                trackingRequests={trackingRequests || []}
                count={count}
                onTogglePopover={(isOpen) => setShouldFetchCountOnly(!isOpen)}
              />
            ) : null}
            <Link href={TRACKING_IMPORT_URL} className="flex gap-2 pr-4 text-baseSm hover:underline">
              Add shipments{' '}
              <span className="grid size-5 place-items-center rounded-md bg-lightBlue-500 leading-none text-white">
                <Plus size={16} />
              </span>
            </Link>
          </div>
        ) : null
      }
    >
      <TrackingAuthWrapper>
        <ShipmentListViewController />
      </TrackingAuthWrapper>
    </AppLayout>
  );
};

export default Page;
